import { UserRoleEnum } from '../enums'
import { PersonalizationModel } from './PersonalizationModel'

/**
 * * Модель текущего пользователя
 */
export class CurrentUserModel {
  /**ID */
  Id!: number
  /**Почта */
  Email!: string
  /**Имя */
  FirstName!: string
  /**Фамилия */
  LastName!: string
  /**Отчество */
  MiddleName!: string
  /**Цвет аватарки */
  AvatarColor!: string
  /**Фото */
  Foto!: string
  /**Роли пользователя */
  Roles!: UserRoleEnum[]
  /**Персонализация пользователя */
  Personalization!: PersonalizationModel

  /**Установка пользователя */
  set(user: CurrentUserModel) {
    Object.assign(this, user)
  }

  constructor(obj?: Partial<CurrentUserModel>) {
    if (obj) Object.assign(this, obj)
  }
}
